<div *ngIf='!destroy' class="btn-choice">
    <li class="response-options" *ngFor='let option of object.options'>
        <button class="open-question" id='btn-chat' name='{{option}}' (click)='selectOption($event)'>{{option}}</button>
    </li>
</div>